// extracted by mini-css-extract-plugin
export default {"wrapper":"MySelect_wrapper__PaY2t","widthAll":"MySelect_widthAll__nbCBo","borderRight":"MySelect_borderRight__0lNpl"};